export const EMAIL_EXCEPTIONS = {
  EMAIL_ALREADY_EXISTS: 'EmailAlreadyExistsException',
  EMAIL_REQUIRED: 'EmailRequiredException',
  INVALID_EMAIL: 'InvalidEmailException',
  LOGIN_INFO_REQUIRED: 'LoginInfoRequiredException',
}

export const USERNAME_EXCEPTIONS = {
  ILEGAL_FORMAT: 'IllegalFormatUsernameException',
  LOGIN_INFO_REQUIRED: 'LoginInfoRequiredException',
  USERNAME_ALREADY_EXISTS: 'UsernameAlreadyExistsException',
  USERNAME_REQUIRED: 'UsernameRequiredException',
}

export const PASSWORD_EXCEPTIONS = {
  EqualPasswordException: 'EqualPasswordException',
  IllegalConcidencePasswordException: 'IllegalConcidencePasswordException',
  IllegalPasswordLengthException: 'IllegalPasswordLengthException',
  InsecurePasswordException: 'InsecurePasswordException',
}

export const VALIDATION_MSG = {
  DNI_ALREADY_EXISTS: 'DniAlreadyExistsException',
  DNI_INVALID: 'DniInvalidException',
  DNI_NO_ALPHANUMERIC: 'DniNoAlphanumericException',
  DNI_WRONG_FORMAT: 'DniWrongFormatException',
}
